import React, { useState, useEffect } from "react";
import {
  Container,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
  Select,
  MenuItem,
  TextField,
} from "@mui/material";
import API_BASE_URL from "../config";

const AdminSupport = () => {
  const [tickets, setTickets] = useState([]);
  const [filter, setFilter] = useState("all");

  useEffect(() => {
    // fetch("http://localhost:5000/api/support")
    fetch(`${API_BASE_URL}/support`)
      .then((response) => response.json())
      .then((data) => {
        if (Array.isArray(data.data)) {
          setTickets(data.data);
        } else {
          console.error("Unexpected response format:", data);
          setTickets([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching tickets:", error);
      });
  }, []);

  const handleStatusChange = (id, newStatus) => {
    setTickets((prevTickets) =>
      prevTickets.map((ticket) =>
        ticket.id === id ? { ...ticket, status: newStatus } : ticket
      )
    );
  };

  const handleResponseChange = (id, newResponse) => {
    setTickets((prevTickets) =>
      prevTickets.map((ticket) =>
        ticket.id === id ? { ...ticket, response: newResponse } : ticket
      )
    );
  };

  const handleSendResponse = async (id) => {
    const ticket = tickets.find((ticket) => ticket.id === id);
    if (!ticket) return;

    try {
      const response = await fetch(`${API_BASE_URL}/support/${id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          status: ticket.status,
          response: ticket.response,
          mail: ticket.mail, // ✅ Include email from frontend
        }),
      });

      if (response.ok) {
        alert(`Response sent to ticket #${id}`);
      } else {
        alert("Failed to send response. Please try again.");
      }
    } catch (err) {
      console.error("Error sending response:", err);
      alert("Error sending response. Please try again.");
    }
  };

  return (
    <Container maxWidth="lg" sx={{ mt: 5, mb: 4 }}>
      <Typography
        variant="h4"
        color="#42326e"
        fontWeight="bold"
        textAlign="center"
        mb={3}
      >
        Admin Support Management
      </Typography>

      <TextField
        select
        label="Filter By Status"
        variant="outlined"
        sx={{ width: "30%", mt: 2, mb: 2 }}
        value={filter}
        onChange={(e) => setFilter(e.target.value)}
      >
        <MenuItem value="all">All</MenuItem>
        <MenuItem value="open">Open</MenuItem>
        <MenuItem value="inprogress">In Progress</MenuItem>
        <MenuItem value="closed">Closed</MenuItem>
      </TextField>

      <Table>
        <TableHead>
          <TableRow>
            {[
              "S.No",
              "User ID",
              "Email",
              "Issue",
              "Status",
              "Response",
              "Actions",
            ].map((header) => (
              <TableCell
                key={header}
                sx={{ color: "#42326e", fontSize: "1rem", fontWeight: "bold" }}
              >
                {header}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {Array.isArray(tickets) &&
            tickets
              .filter((ticket) => filter === "all" || ticket.status === filter)
              .map((ticket, index) => (
                <TableRow key={ticket.id}>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>{ticket.user_id}</TableCell>
                  <TableCell>{ticket.mail}</TableCell>
                  <TableCell>{ticket.message}</TableCell>
                  <TableCell>
                    <Select
                      value={ticket.status}
                      onChange={(e) =>
                        handleStatusChange(ticket.id, e.target.value)
                      }
                    >
                      <MenuItem value="open">Open</MenuItem>
                      <MenuItem value="inprogress">In Progress</MenuItem>
                      <MenuItem value="closed">Closed</MenuItem>
                      
                    </Select>
                  </TableCell>
                  <TableCell>
                    <TextField
                      fullWidth
                      variant="outlined"
                      value={ticket.response}
                      onChange={(e) =>
                        handleResponseChange(ticket.id, e.target.value)
                      }
                    />
                  </TableCell>
                  <TableCell>
                    <Button
                      variant="contained"
                      sx={{
                        backgroundColor: "#42326e",
                        color: "white",
                        "&:hover": {
                          backgroundColor: "black",
                          color: "white",
                        },
                      }}
                      onClick={() => handleSendResponse(ticket.id)}
                    >
                      Apply
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
        </TableBody>
      </Table>
    </Container>
  );
};

export default AdminSupport;
